export function firstError(response) {
    let errors = parseResponseErrors(response);
    if(Array.isArray(errors) && errors.length) {
        return errors[0];
    }
    return false;
}


export function parseResponseErrors(response) {

    if(response && !Array.isArray(response) && response.title) {
        return [response];
    }

    if(response && response.response && response.response.data && response.response.data.errors && Array.isArray(response.response.data.errors)) {
        return response.data.errors;
    } else if(response && response.data && response.data.errors && Array.isArray(response.data.errors)) {
        return response.data.errors;
    } else if(response && response.errors) {
        return response.errors;
    }

    return false;
}